import { render, staticRenderFns } from "./AvailableEvents.vue?vue&type=template&id=f0d12070"
import script from "./AvailableEvents.vue?vue&type=script&lang=js"
export * from "./AvailableEvents.vue?vue&type=script&lang=js"
import style0 from "./AvailableEvents.vue?vue&type=style&index=0&id=f0d12070&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports